import { TextField } from "@mui/material";
import { Button } from "@mui/material";
import React, { useState } from "react";

const GrievanceForm = ({ userId, firstName, lastName, mobile, onSubmit }) => {
  const [grievance, setGrievance] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const newGrievance = {
      userId,
      firstName,
      lastName,
      mobile,
      grievance,
    };

    onSubmit(newGrievance);
    setGrievance("");
  };

  return (
    <>
    
      <h1 className="text-center text-3xl mb-2 mt-6">Enter Your Grievance</h1>
    <div className="flex w-full justify-center relative top-10">
      <form onSubmit={handleSubmit} className="flex flex-col w-96 space-y-2 ">
        <textarea
          value={grievance}
          onChange={(e) => setGrievance(e.target.value)}
          rows={4}
          placeholder="Enter your grievance here"
          required
        ></textarea>
        <Button variant="contained" type="submit">Submit</Button>
      </form>
    </div>
    </>
  );
};

export default GrievanceForm;
